import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Input } from '../components/ui/input';

const Layout = ({ searchTerm, setSearchTerm }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <div className="flex space-x-8">
              <Link to="/" className="text-xl font-bold text-gray-800">
                Cookbook
              </Link>
              <div className="flex space-x-4">
                <Link to="/category/mains" className="text-gray-600 hover:text-gray-900">
                  Mains
                </Link>
                <Link to="/category/soups" className="text-gray-600 hover:text-gray-900">
                  Soups
                </Link>
                <Link to="/category/sides" className="text-gray-600 hover:text-gray-900">
                  Sides
                </Link>
                <Link to="/category/sauces" className="text-gray-600 hover:text-gray-900">
                  Sauces
                </Link>
                <Link to="/category/desserts" className="text-gray-600 hover:text-gray-900">
                  Desserts
                </Link>
              </div>
            </div>
            <div className="w-72">
              <Input 
                type="search" 
                placeholder="Search recipes..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full"
              />
            </div>
          </div>
        </div>
      </nav>
      <main className="max-w-7xl mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;